'use client';

import clsx from 'clsx';
import { useContext } from 'react';
import HeaderContext, { HeaderContextType } from '@/context/HeaderContext';
import styles from './Burger.module.css';

const Burger = () => {
  const { isMenuOpened, setIsMenuOpened } = useContext(HeaderContext) as HeaderContextType;
  return (
    <div
      id="main-menu-icon"
      data-testid="main-menu-icon"
      className={clsx(styles.burger, { [styles.burgerActive]: isMenuOpened })}
      onClick={() => setIsMenuOpened(!isMenuOpened)}
    ></div>
  );
};

export default Burger;
